import React, { useEffect, useState, useRef } from 'react';
import './Profile.css'
import { Link as Anchor } from 'react-router-dom';
import { API_ENDPOINTS } from '../../config/api';
import ShareWeb from '../ShareWeb/ShareWeb'
export default function Profile() {
    const [tienda, setTienda] = useState([]);
    useEffect(() => {
        cargarTienda();
    }, []);


    const cargarTienda = () => {
        fetch(API_ENDPOINTS.tiendas, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                const tiendaData = data?.tiendas?.[0] || {};
                setTienda(tiendaData);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };


    return (
        <div className='profileContain'>
            {tienda?.imagen1_url ? (
                <img src={tienda?.imagen1_url} alt="logo" className="profile-logo" />
            ) : (
                <></>
            )}
            <h2>{tienda?.nombre || 'Sistema'}</h2>
            <div className='profileText'>
                <p>{tienda.eslogan}</p>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`} target="_blank">{tienda.direccion}</Anchor>
                <div className='socials'>
                    <Anchor to={tienda.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
                    <Anchor to={`tel:${tienda.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
                    <Anchor to={tienda.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>
                </div>
            </div>

            <ShareWeb />
        </div>
    )
}
